import { firebaseLogEvent } from 'utils/firebase';
import { usePaymentMethod } from 'utils/store/paymentMethod';

import { PaymentMethod, usePaymentMethodsQuery } from '@/graphql/paymentMethods';

import ExistingPaymentMethod from './ExistingPaymentMethod';
import PaymentRequest from './PaymentRequest';
import PayPalRequest from './PayPalRequest';

interface Props {
  editing?: boolean;
}
export default function PaymentMethods({ editing = false }: Props) {
  const { setPaymentMethod, getPaymentMethod, paymentMethodType, getPaymentMethodId } = usePaymentMethod();
  const { data, refetch } = usePaymentMethodsQuery();
  const paymentMethods = data?.paymentMethods?.data;

  return (
    <>
      <PaymentRequest
        editing={editing}
        onClick={() => {
          firebaseLogEvent('GivingButtonTap', {
            label: 'Payment Method',
            screen: 'giving_payment_methods',
            value: paymentMethodType,
          });
          setPaymentMethod('paymentRequest');
        }}
        selected={getPaymentMethod() === 'paymentRequest'}
      />
      <PayPalRequest
        editing={editing}
        onClick={() => setPaymentMethod('paypal')}
        selected={getPaymentMethod() === 'paypal'}
      />
      {paymentMethods?.map((paymentMethod: PaymentMethod) => (
        <ExistingPaymentMethod
          editing={editing}
          key={paymentMethod.id}
          onClick={() => setPaymentMethod(paymentMethod.id)}
          paymentMethod={paymentMethod}
          refetchPaymentMethods={refetch}
          selected={getPaymentMethodId() === paymentMethod.id}
        />
      ))}
    </>
  );
}
